module.exports = __webpack_public_path__ + "img/AB5_7442.29ddca90.jpg";